"use strict";

(function () {
  'use strict';

  angular.module('realtimemanagerAPP', ['lr.core', 'lr.Auth', 'lr.components', 'lr.services', 'lr.Dashboard', 'lr.Nav', 'lr.Properties', 'lr.Settings', 'lr.Utils', 'lr.messagecontroller', 'ui.bootstrap', 'ui.select']);
})();